var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpwardRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75004 14.2501V5.87261L13.41 9.53261C13.7025 9.82511 14.1825 9.82511 14.475 9.53261C14.7675 9.24011 14.7675 8.76761 14.475 8.47511L9.53254 3.53261C9.24004 3.24011 8.76754 3.24011 8.47504 3.53261L3.52504 8.46761C3.23254 8.76011 3.23254 9.23261 3.52504 9.52511C3.81754 9.81761 4.29004 9.81761 4.58254 9.52511L8.25004 5.87261V14.2501C8.25004 14.6626 8.58754 15.0001 9.00004 15.0001C9.41254 15.0001 9.75004 14.6626 9.75004 14.2501Z",
    fill: "#D32F2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpwardRounded);
export default __webpack_public_path__ + "static/media/ArrowUpwardRounded.98c676eb1f4ead765d7501ee31db25d9.svg";
export { ForwardRef as ReactComponent };